import {trackAmplitudeViewSection} from "../../../tracking/amplitude/track_amplitude_view_section";
import {PricesCityAnalyticsLocation} from "./prices_city_analytics";

export type PricesCitySectionName =
    | "price_differences"
    | "calculator"
    | "districts_table"
    | "price_trend"
    | "glossary"
    | "address_prices"
    | "address_comparison"
    | "address_trend";

export const trackPricesCityViewSection = (sectionName: PricesCitySectionName, location: PricesCityAnalyticsLocation) => {
    trackAmplitudeViewSection({
        sectionName,
        location
    });
};
import {trackAmplitudeViewSection} from "../../../tracking/amplitude/track_amplitude_view_section";
import {PricesCityAnalyticsLocation} from "./prices_city_analytics";

export type PricesCitySectionName =
    | "price_differences"
    | "calculator"
    | "districts_table"
    | "price_trend"
    | "glossary"
    | "address_prices"
    | "address_comparison"
    | "address_trend";

export const trackPricesCityViewSection = (sectionName: PricesCitySectionName, location: PricesCityAnalyticsLocation) => {
    trackAmplitudeViewSection({
        sectionName,
        location
    });
};
